import * as React from 'react';
import styled from 'styled-components';
import template from '@westwing/ui-kit/template';
import { body1, body2 } from '@westwing/ui-kit/typography';
import { forTablet, forWideScreens } from '@westwing/ui-kit/breakPoints';
import Text from '@ids/components/Typography/Text';
import Heading from '@ids/components/Typography/Heading';
import MediaImage from '@ids/components/Media/MediaImage';
import ActionButton from '@ids/components/ActionButton/ActionButton';
import { scrollMarginToSection } from '@ids/components/Layout/utils';

export const OfflineStudioSection = styled.section`
    display: grid;
    align-items: center;
    gap: 4vw 0;
    min-height: 240px;

    ${scrollMarginToSection}

    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas:
        'media'
        'content';

    ${forTablet`
        grid-template-rows: 1fr;
        grid-template-columns: 43% 57%;
        grid-template-areas: 'content media';
    `}

    ${forWideScreens`
        grid-template-columns: 40% 60%;
    `}
`;

export const MediaContainer = styled.div`
    grid-area: media;

    ${forTablet`
        padding-right: 4vw;
    `}
`;

export const Image = styled(MediaImage)`
    position: relative;
`;

export const TextBox = styled.div`
    color: ${({ theme }) => theme.colors.charcoal100};
    padding: 0 4vw;

    ${Heading} {
        margin-bottom: 10px;
    }

    grid-area: content;
`;

export const PromotionalTag = styled(Text)`
    font-weight: 420;
    font-size: 14px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.red100};
`;

export const Title = styled(Heading)`
    ${forTablet`
        font-size: 34px;
    `}
    margin-top: 0.25em;
`;

export const TextContent = styled.div`
    ${body1}
    white-space: pre-line;
    margin-bottom: 1rem;
`;

export const Hint = styled(TextContent)`
    ${body2}
`;

export function Description({ content }: { content: string }) {
    return <TextContent dangerouslySetInnerHTML={{ __html: template(content) }} />;
}

export const CTAButton = styled(ActionButton)`
    height: 50px;
    transition: none;
`;
